// extracted by mini-css-extract-plugin
module.exports = {"pagination":"PaginationNew_pagination__zTbLM","section":"PaginationNew_section__s5XP5","button":"PaginationNew_button___UIej","pages":"PaginationNew_pages__qvrRh"};